export default {
  estudante: null,
  estudanteSimulacao: null,
  estudantes: [],
  paginacao: {},
  formSimulacao: {},
  variaveisSimulacao: [],
  variaveisImportancia: [],
  variaveisInformacoes: [],
  modelo: null,
  ordenacaoBusca: {
    campo: 'nome_aluno',
    ordem: 1,
  },
  formBusca: {
    unidade: null,
    unidades: [],
    modalidade: null,
    modalidades: [],
    curso: null,
    cursos: [],
    versao: null,
    versoes: [],
    turma: null,
    turmas: [],
    nome: "",
    pagina: 1,
    faixa_evasao: [0, 100],
  },
}



// WEBPACK FOOTER //
// ./src/pages/estudantes/store/state.js